import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import API_ENDPOINTS from '../../api';
import logo from '../../assets/images/phonevue-logo.svg';
// import twitter from '../../assets/icons/x-logo.svg';
import instagram from '../../assets/icons/instagram_footer.svg';
import linkedin from '../../assets/icons/Group36.svg';
import facebook from '../../assets/icons/Shape.svg';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const emailToSubmit = email; // Store email before clearing
    setEmail(''); // Clear input immediately when button is clicked
    setLoading(true);

    try {
      const response = await fetch(API_ENDPOINTS.SUBSCRIBE.SUBSCRIBE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: emailToSubmit,
        }),
      });

      // No error handling or messages shown to user
    } catch (error) {
      // Silently handle errors - no user feedback
      console.error('Subscription error:', error);
    } finally {
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-left">
            <Link to="/" className="footer-logo" onClick={scrollToTop}>
              <div className="footer-logo-background">
                <img src={logo} alt="PhoneVue" />
              </div>
            </Link>
            <div className="social-icons">
              <a href="https://www.linkedin.com/in/bhavik-kumar-663586358" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <img src={linkedin} alt="LinkedIn" />
              </a>
              <a href="https://www.facebook.com/share/1DMM76MGpR/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <img src={facebook} alt="Facebook" />
              </a>
              {/* <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Twitter">
                <img src={twitter} alt="Twitter" />
              </a> */}
              <a href="https://www.instagram.com/phonevue.in/?igsh=MWg2eXNpZGd0Z2VhYQ%3D%3D&utm_source=qr#" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <img src={instagram} alt="Instagram" />
              </a>
            </div>
          </div>
          <div className="footer-center">
            <nav className="footer-nav">
              <Link to="/about-us" className="footer-nav-link">ABOUT US</Link>
              <Link to="/" className="footer-nav-link">PHONEVUE</Link>
              {/* <Link to="#" className="footer-nav-link">BATTERY DEGRADATION</Link> */}
              <Link to="/contact-us" className="footer-nav-link">CONTACT US</Link>
            </nav>
          </div>
          <div className="footer-right">
            <h3 className="subscribe-heading">Subscribe</h3>
            <form className="subscribe-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="subscribe-input"
                required
                disabled={loading}
              />
              <button type="submit" className="subscribe-button" aria-label="Subscribe" disabled={loading}>
                {loading ? (
                  <span>...</span>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 3L14 10L7 17" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <div className="footer-bottom-left">
            <Link to="/terms-conditions" className="footer-bottom-link">Terms</Link>
            <Link to="/privacy-policy" className="footer-bottom-link">Privacy</Link>
            {/* <Link to="/data-privacy-account-details" className="footer-bottom-link">Account Deletion</Link> */}
          </div>
          <div className="footer-bottom-right">
            <p>Copyright © {new Date().getFullYear()} <strong>PhoneVue Pvt. Ltd.</strong></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

